import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';

import { IssueModel } from '@app/core/models/api-response/pending-issue.model';

import { PendingIssueEnum } from '@core/enums/pending-issues.enum';

interface PendingIssueItem {
  title: string;
  description: string;
}

const pendingIssueItemMap: Record<
  PendingIssueEnum,
  (issue: IssueModel) => PendingIssueItem
> = {
  [PendingIssueEnum.Invalid]: () => ({
    title: 'Pendência inválida',
    description: 'Esta pendência não é válida.'
  }),
  [PendingIssueEnum.PendingStudentsProgress]: (issue) => ({
    title: 'Alunos com pendências',
    description: `Há ${issue.total} alunos com pendências.`
  }),
  [PendingIssueEnum.ClassImage]: () => ({
    title: 'Foto da turma',
    description: 'Adicionar em gerenciar turma.'
  }),
  [PendingIssueEnum.ClassBiography]: () => ({
    title: 'Biografia da turma',
    description: 'Preencher na área de turmas.'
  }),
  [PendingIssueEnum.TeacherBiography]: () => ({
    title: 'Biografia do(a) professor(a)',
    description: 'Preencher na área de turmas.'
  })
};

@Component({
  standalone: true,
  selector: 'mw-pending-issue-item',
  imports: [DatePipe],
  templateUrl: './pending-issue-item.component.html',
  styleUrl: './pending-issue-item.component.scss'
})
export class PendingIssueItemComponent {
  readonly title = input.required<string>();
  readonly deadline = input.required<Date | string>();
  readonly hasBeenSentToPrinting = input.required<boolean>();
  readonly issues = input.required<PendingIssueItem[], IssueModel[]>({
    transform: (issues) => this.pendingIssueTransform(issues)
  });

  readonly pendingIssueEnum = PendingIssueEnum;
  private readonly issuesOrder = {
    [PendingIssueEnum.PendingStudentsProgress]: 0,
    [PendingIssueEnum.ClassImage]: 1,
    [PendingIssueEnum.ClassBiography]: 2,
    [PendingIssueEnum.TeacherBiography]: 3
  };

  private pendingIssueTransform(issues: IssueModel[]): PendingIssueItem[] {
    return issues
      .sort(
        (a, b) =>
          (this.issuesOrder[a.type] || 0) - (this.issuesOrder[b.type] || 0)
      )
      .map((issue) => pendingIssueItemMap[issue.type](issue));
  }
}
